import { useEffect } from "react";
import { NavBar } from "@/components/landing/NavBar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Identificacion } from "@/components/landing/Identificacion";
import { Valor } from "@/components/landing/Valor";
import { Compartir } from "@/components/landing/Compartir";
import { ComoFunciona } from "@/components/landing/ComoFunciona";
import { ParaQuien } from "@/components/landing/ParaQuien";
import { Normas } from "@/components/landing/Normas";
import { Precio } from "@/components/landing/Precio";
import { Creador } from "@/components/landing/Creador";
import { Preguntas } from "@/components/landing/Preguntas";
import { CtaFinal } from "@/components/landing/CtaFinal";
import { Footer } from "@/components/landing/Footer";
import { CookieNotice } from "@/components/landing/CookieNotice";
import { StickyCta } from "@/components/landing/StickyCta";
import { captureUtms } from "@/lib/utm";
import { trackEvent } from "@/lib/analytics";

export default function LandingPage() {
  useEffect(() => {
    captureUtms();
    trackEvent("landing_view");
  }, []);

  return (
    <main data-testid="landing-page" className="min-h-screen bg-[#0B1120] pb-20 md:pb-0">
      <NavBar />
      <Hero />
      <Marquee />
      <Identificacion />
      <Valor />
      <Compartir />
      <ComoFunciona />
      <ParaQuien />
      <Normas />
      <Precio />
      <Creador />
      <Preguntas />
      <CtaFinal />
      <Footer />
      <CookieNotice />
      <StickyCta />
    </main>
  );
}
